<app-form (onsubmit)="submit()">
  <div class="space-y-4">
    <div class="flex flex-col gap-4">
      <div class="flex justify-evenly gap-4 not-sm:flex-wrap">
        <app-select [required]="true" #widthSelect [autofocus]="true" placeholder="Width" [options]="widths()" [selected]="lookupStore.size.selected_width() ?? ''" (selectedChange)="onWidthChange($event)" class="w-full min-w-36"/>

        <app-select [required]="true" #ratioSelect placeholder="Aspect Ratio" [options]="ratios()" [selected]="lookupStore.size.selected_ratio() ?? ''" (selectedChange)="onRatioChange($event)" [disabled]="ratiosDisabled()" class="w-full min-w-36"/>

        <app-select [required]="true" #diameterSelect placeholder="Rim Diameter" [options]="diameters()" [selected]="lookupStore.size.selected_diameter() ?? ''" [disabled]="diametersDisabled()" (selectedChange)="onDiameterChange($event)" (keyup.enter)="submit()" class="w-full min-w-36"/>
      </div>
    </div>

    <app-button type="submit" variant="primary">View Results</app-button>
  </div>
</app-form>
